import { Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { SaveToListType } from '@app/modules/tf-shared-list/models/types/save-to-list.type';
import { TfUserDataService } from '@app/modules/tf-user-data';
import { TfWindowRefService } from '@app/modules/tf-window-ref';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TfSharedListInfoModalComponent } from '../tf-shared-list-info-modal/tf-shared-list-info-modal.component';

@Component({
    selector: 'tf-shared-list',
    templateUrl: './tf-shared-list.component.html',
    styleUrls: ['./tf-shared-list.component.scss']
})
export class TfSharedListComponent {

    @Input() disabled: boolean;
    @Input() assay: SaveToListType;

    @Output() onItemAddedToList: EventEmitter<SaveToListType> = new EventEmitter<SaveToListType>();

    @ViewChild('sharedListContainer') sharedListContainer: ElementRef;

    visible: boolean = false;
    eventListener = null;
    window: any;

    get showSharedList(): boolean {
        return this.productSiteRegionService.isThermofisher();
    }

    constructor(
        private ngbModal: NgbModal,
        private renderer: Renderer2,
        private element: ElementRef,
        private userDataSrv: TfUserDataService,
        private productSiteRegionService: ProductSiteRegionService,
        private windowRef: TfWindowRefService
    ) {
        this.window = this.windowRef.nativeWindow;
    }

    bindEvents() {
        this.eventListener = this.renderer.listen('window', 'click', (event => {
            this.clickEventHandler(event);
        }));
    }

    unbindEvents() {
        this.eventListener();
    }

    clickEventHandler(e: Event) {

        let target = (<HTMLElement>e.target);
        let parentFound = false;

        while (target && !parentFound) {
            if (target === this.element.nativeElement) {
                parentFound = true;
                break;
            }
            target = target.parentElement;
        }

        if (!parentFound) {
            this.close();
        }

    }

    toggleSaveToList() {
        if (this.isLoggedIn() == false) {
            this.signIn();
            return;
        }
        if (this.visible) {
            this.close();
        } else {
            this.open();
        }

    }

    open() {
        this.visible = true;
        this.bindEvents();
    }

    close() {
        this.visible = false;
        this.unbindEvents();
    }

    openAbout() {
        this.ngbModal.open(TfSharedListInfoModalComponent, {
            windowClass: 'shared-list-modal',
            backdrop: 'static'
        });
    }

    onItemAddedToListHandler($event) {
        this.onItemAddedToList.emit($event);
    }

    signIn(){
        if( this.userDataSrv.getIsLoggedInValue() === false){
            const commergentHost = this.window?.$m?.magellanConfig?.comergentHost;
            const commergentBasePath = this.window?.$m?.magellanConfig?.comergentBasePath;
            let loginUrl = '';
            if (commergentHost && commergentBasePath) {
                const comergentHost = this.window.$m['magellanConfig']['comergentHost'];
                const comergentBasePath = this.window.$m['magellanConfig']['comergentBasePath'];
                loginUrl = 'https://' + comergentHost + comergentBasePath + 'LoginRequired';
            } else {
                loginUrl = '/auth/login?';
            }

            this.window.location.href = loginUrl + 'returnUrl=' + encodeURIComponent(this.window.location.href);
        }
    }

    isLoggedIn(): boolean {
        return this.userDataSrv.getIsLoggedInValue();
    }
}
